<template>
<div>
 <Header @getLanguageMap='getLanguageMap'></Header>
<!-- <div class="crumbs">
  <div class="container">
    <p class="title">{{languageMap['解码驱动']}}</p>
    <div class="childs"> <a href="/#/">{{languageMap['主页']}}</a> &gt; <a href="/#/focus/">{{languageMap['市场焦点']}}</a> &gt; <a href="/#/focus/jmqd/">{{languageMap['解码驱动']}}</a> &gt;  </div>
  </div>
</div> -->
<NavigationBar></NavigationBar>
<div class="main">
  <div class="container">
  

    <div class="maxTitle"> <span class="title">{{languageMap['解码驱动']}}</span>
      <div class="sub"></div>
    </div>

    <div class="mainContent"> 
	
	
	 
		
		
		
		
      <div class="pages">  <li><span class="pageinfo">{{languageMap['共']}} <strong>0</strong>{{languageMap['页']}}<strong>0</strong>{{languageMap['条记录']}}</span></li>

 </div>
    </div>
  </div>
</div>
 <Footer></Footer>
</div>
</template>

<style scoped>
/* news.css */
.mainHead {
	padding-top:40px;
}
.mainHead:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.mainHead .left {
	width:435px;
	height:225px;
	line-height:225px;
	float:left;
}
.mainHead .left img {
	vertical-align:middle;
	width:100%;
	height:100%;
}
.mainHead .right {
	position:relative;
	width:656px;
	float:right;
}
.mainHead .right {
	line-height:26px;
	color:#666;
	font-size:14px;
}
.mainHead .right a {
	font-family:Arial, Helvetica, sans-serif;
	color:#0C75D2;
}
.mainContent .child {
	width:285px;
	margin-right:10px;
	vertical-align:text-top;
	padding-top:60px;
	display:inline-block;
*display:inline;
*zoom:1;
}
.mainContent .child .childImg {
	overflow:hidden;
	position:relative;
	width:285px;
	height:190px;
	line-height:212px;
	text-align:center;
}
.mainContent .child .childImg {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child:hover .childImg {
	-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-o-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
}
.mainContent .child .childImg .childImgimg {
	width:100%;
	height:100%;
	vertical-align: top;
}
.mainContent .child .childImg .childHide {
	opacity:0;
	position:absolute;
	top:0px;
	left:-100%;
	width:100%;
	height:100%;
	background-image: linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -o-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -moz-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -webkit-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -ms-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(232,232,232, 0.8)), color-stop(1, rgba(214,214,214, 0.8)));
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e8e8e8', endColorstr='#d6d6d6'), progid: DXImageTransform.Microsoft.Alpha(Opacity=0);
}
.mainContent .child .childImg .childHide {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child .childImg .childHide .childHideIcon {
	display:inline-block;
*display:inline;
*zoom:1;
	margin:0 2px;
	cursor:pointer;
	width:36px;
	height:36px;
	text-align:center;
	line-height:36px;
	border-radius:36px;
	-moz-border-radius:36px;
	-ms-border-radius:36px;
	-o-border-radius:36px;
	-webkit-border-radius:36px;
	background:#5f5f5f;
}
.mainContent .child .childImg .childHide .childHideIcon {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child .childImg .childHide .childHideIcon:hover {
	background:#000;
}
.mainContent .child .childImg .childHide .childHideIcon img {
	vertical-align:middle;
}
.mainContent .child .childImg:hover .childHide {
	left:0;
	opacity:1;
}
.mainContent .child .childTitle {
	line-height:24px;
	padding:20px 0 0 0;
	color:#333333;
	font-size:14px;
}
.mainContent .child .childTime {
	line-height:22px;
	padding:6px 0;
	color:#999999;
	font-size:12px;
}
.mainContent .child .childInfo {
	line-height:22px;
	font-size:12px;
	color:#666;
}
 @keyframes newsChild {
0% {
opacity:0;
transform:scale(0);
}
100% {
opacity:1;
transform:scale(1);
}
}
@-moz-keyframes newsChild {
0% {
opacity:0;
-moz-transform:scale(0);
}
100% {
opacity:1;
-moz-transform:scale(1);
}
}
@-webkit-keyframes newsChild {
0% {
opacity:0;
-webkit-transform:scale(0);
}
100% {
opacity:1;
-webkit-transform:scale(1);
}
}
@-o-keyframes newsChild {
0% {
opacity:0;
-o-transform:scale(0);
}
100% {
opacity:1;
-o-transform:scale(1);
}
}
@media (max-width: 639px) {
.mainHead {
	padding-top:20px;
}
.mainHead .left {
	width:100%;
	height:auto;
	line-height:normal;
	float:none;
}
.mainHead .right {
	width:100%;
	float:right;
	margin:10px 0 0 0;
}
.mainHead .right {
	line-height:22px;
	font-size:12px;
}
.mainContent .child {
	width:100%;
	margin-right:0px;
	padding-top:30px;
}
.mainContent .child .childImg {
	width:100%;
	height:auto;
	line-height:none;
}
.mainContent .child .childTitle {
	line-height:24px;
	padding:10px 0 0 0;
	font-size:14px;
}
.mainContent .child .childTime {
	line-height:20px;
	padding:4px 0;
	font-size:12px;
}
.mainContent .child .childInfo {
	line-height:20px;
	font-size:12px;
}
}
@media (min-width: 640px) and (max-width:1023px ) {
.mainHead {
	padding-top:40px;
}
.mainHead .left {
	width:100%;
	height:auto;
	line-height:normal;
	float:none;
}
.mainHead .right {
	width:100%;
	float:right;
	margin:20px 0 0 0;
}
.mainHead .right {
	line-height:26px;
	font-size:14px;
}
.mainContent .child {
	width:285px;
	margin-right:10px;
	padding-top:60px;
}
.mainContent .child .childImg {
	width:285px;
	height:212px;
	line-height:212px;
}
.mainContent .child .childTitle {
	line-height:24px;
	padding:20px 0 0 0;
	font-size:14px;
}
.mainContent .child .childTime {
	line-height:22px;
	padding:6px 0;
	font-size:12px;
}
.mainContent .child .childInfo {
	line-height:22px;
	font-size:12px;
}
}
@media (min-width: 1024px) and (max-width:1199px ) {
.mainHead {
	padding-top:30px;
}
.mainHead .left {
	width:355px;
	height:183px;
	line-height:183px;
}
.mainHead .right {
	width:535px;
}
}
@media (min-width: 1200px) and (max-width:1439px ) {
}
@media (min-width: 1440px) and (max-width:1920px ) {
}
.pages {
	text-align:center;
	margin: 64px 0 0 0;
}
.pages a, .pages span {
	display:inline-block;
	padding:9px 14px;
	margin:0 1px;
	border:1px solid #f0f0f0;
	-webkit-border-radius:3px;
	-moz-border-radius:3px;
	border-radius:3px;
}
.pages a, .pages li {
	display:inline-block;
	list-style: none;
	text-decoration:none;
	color:#58A0D3;
}
.pages a.first, .pages a.prev, .pages a.next, .pages a.end {
	margin:0;
}
.pages a:hover {
	border-color:#50A8E6;
}
.pages span.current {
	background:#50A8E6;
	color:#FFF;
	font-weight:700;
	border-color:#50A8E6;
}
/* lightbox.css */
/* {{languageMap['简悦网络（www']}}.jianyuenet.com）{{languageMap['做最好的织梦模板网站 QQ']}}:780000068 */
/* Preload images */
/* body:after {
	content: url(../img/close.png) url(../img/loading.gif) url(../img/prev.png) url(../img/next.png);
	display: none;
} */
.lightboxOverlay {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9999;
	background-color: black;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
	opacity: 0.8;
	display: none;
}
.lightbox {
	position: absolute;
	left: 0;
	width: 100%;
	z-index: 10000;
	text-align: center;
	line-height: 0;
	font-weight: normal;
}
.lightbox .lb-image {
	display: block;
	height: auto;
	max-width: inherit;
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	-ms-border-radius: 3px;
	-o-border-radius: 3px;
	border-radius: 3px;
}
.lightbox a img {
	border: none;
}
.lb-outerContainer {
	position: relative;
	background-color: white;
 *zoom: 1;
	width: 250px;
	height: 250px;
	margin: 0 auto;
	-webkit-border-radius: 4px;
	-moz-border-radius: 4px;
	-ms-border-radius: 4px;
	-o-border-radius: 4px;
	border-radius: 4px;
}
.lb-outerContainer:after {
	content: "";
	display: table;
	clear: both;
}
.lb-container {
	padding: 4px;
}
.lb-loader {
	position: absolute;
	top: 43%;
	left: 0;
	height: 25%;
	width: 100%;
	text-align: center;
	line-height: 0;
}
.lb-cancel {
	display: block;
	width: 32px;
	height: 32px;
	margin: 0 auto;
	background: url(/templets/111/images/loading.gif) no-repeat;
}
.lb-nav {
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 10;
}
.lb-container > .nav {
	left: 0;
}
.lb-nav a {
	outline: none;
	background-image: url('data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==');
}
.lb-prev, .lb-next {
	height: 100%;
	cursor: pointer;
	display: block;
}
.lb-nav a.lb-prev {
	width: 34%;
	left: 0;
	float: left;
	background: url(/templets/111/images/prev.png) left 48% no-repeat;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
	opacity: 0;
	-webkit-transition: opacity 0.6s;
	-moz-transition: opacity 0.6s;
	-o-transition: opacity 0.6s;
	transition: opacity 0.6s;
}
.lb-nav a.lb-prev:hover {
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity: 1;
}
.lb-nav a.lb-next {
	width: 64%;
	right: 0;
	float: right;
	background: url(/templets/111/images/next.png) right 48% no-repeat;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
	opacity: 0;
	-webkit-transition: opacity 0.6s;
	-moz-transition: opacity 0.6s;
	-o-transition: opacity 0.6s;
	transition: opacity 0.6s;
}
.lb-nav a.lb-next:hover {
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity: 1;
}
.lb-dataContainer {
	margin: 0 auto;
	padding-top: 5px;
 *zoom: 1;
	width: 100%;
	-moz-border-radius-bottomleft: 4px;
	-webkit-border-bottom-left-radius: 4px;
	border-bottom-left-radius: 4px;
	-moz-border-radius-bottomright: 4px;
	-webkit-border-bottom-right-radius: 4px;
	border-bottom-right-radius: 4px;
}
.lb-dataContainer:after {
	content: "";
	display: table;
	clear: both;
}
.lb-data {
	padding: 0 4px;
	color: #ccc;
}
.lb-data .lb-details {
	width: 85%;
	float: left;
	text-align: left;
	line-height: 1.1em;
}
.lb-data .lb-caption {
	font-size: 13px;
	font-weight: bold;
	line-height: 1em;
}
.lb-data .lb-number {
	display: block;
	clear: left;
	padding-bottom: 1em;
	font-size: 12px;
	color: #999999;
}
.lb-data .lb-close {
	display: block;
	float: right;
	width: 30px;
	height: 30px;
	background: url(/templets/111/images/close.png) top right no-repeat;
	text-align: right;
	outline: none;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=70);
	opacity: 0.7;
	-webkit-transition: opacity 0.2s;
	-moz-transition: opacity 0.2s;
	-o-transition: opacity 0.2s;
	transition: opacity 0.2s;
}
.lb-data .lb-close:hover {
	cursor: pointer;
 filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity: 1;
}

</style>

<script>
import store from "@/store";
import config from "@/config";
import Header from "@/components/front/Header.vue";
import Footer from "@/components/front/Footer.vue";
import NavigationBar from "@/components/front/NavigationBar.vue";
export default {
  data() {
    return {
       languageMap:{}
    };
  },
  mounted() {

  },
  beforeDestroy(){

  },
  methods: {
   getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    getLanguageMap(e){
      this.languageMap=e;
      this.$emit('getLanguageMap',e)
    }
  },
  components: {
    Header,
    Footer,
    NavigationBar
  }
};
</script>
